import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { AuthenticationStore } from './authentication.store';
import { UserLocalStorageService } from './user.local.storage.service';

export function authFactory(http: Http, options: RequestOptions, userLocalStorageService: UserLocalStorageService) {
  return new AuthHttp(new AuthConfig({
    // Config options if you want
    noTokenScheme: true,
    tokenName: AuthenticationStore.TOKEN_NAME,
    tokenGetter: () => userLocalStorageService.getToken(),
    noJwtError: true,       // Prevent errors for non-JWT tokens
    noClientCheck: true,
    globalHeaders: [
      {'Cache-Control': 'no-cache, no-store, must-revalidate'},
      {'Pragma': 'no-cache'},
      {'Expires': 'Thu, 01 Jan 1970 00:00:00 GMT'},
      {'If-Modified-Since': '0'}
    ],
  }), http, options);
}

// Include this in your ngModule providers
export const authProvider = {
  provide: AuthHttp,
  deps: [Http, RequestOptions, UserLocalStorageService],
  useFactory: authFactory
};



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/services/angular2-jwt.config.ts